var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstallAppIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f3",
    d: "M5.647 0h20.706A5.647 5.647 0 0 1 32 5.647v20.706A5.647 5.647 0 0 1 26.353 32H5.647A5.647 5.647 0 0 1 0 26.353V5.647A5.647 5.647 0 0 1 5.647 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3133",
    d: "M7.529 2.824h16.942a4.706 4.706 0 0 1 4.705 4.705v16.942a4.706 4.706 0 0 1-4.705 4.705H7.529a4.706 4.706 0 0 1-4.705-4.705V7.529a4.706 4.706 0 0 1 4.705-4.705z",
    strokeWidth: 1.882
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.412v13.176M9.412 16h13.176",
    stroke: "#2F3133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.882
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallAppIos);
export default __webpack_public_path__ + "static/media/installAppIos.85aadaf1d714d245b5f231df1cd51904.svg";
export { ForwardRef as ReactComponent };